import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Epe, Vote } from 'app/models/epe';
import { EpesService } from 'app/services/epes.service';
import { SopService } from 'app/services/sop.service';
import { Alert } from 'app/shared/alerts/simple-message/simple-message.component';
import { SessionStorage } from 'app/storage/session.storage';
import { SopStorage } from 'app/storage/sop.storage';
import { Logger } from 'app/utilities/logger';
import { catchError, lastValueFrom, of } from 'rxjs';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { ApplicationsService } from 'app/services/applications.service';
import { TOPIC_GROUPS } from 'app/models/epe-topics';

enum EpeStatusFilterEnum {
  all,
  draft,
  pending,
  eligible,
  not_eligible,
  voted
}
interface exportEpe {
  [key: string]: string;
}
@Component({
  selector: 'app-epes',
  templateUrl: './epes.component.html',
  styleUrls: ['./epes.component.scss', '../sop.component.scss']

})
export class EpesComponent implements OnInit{
  loading: boolean = true
  epes:Epe[] | null = []
  selected: string = ''
  EpeStatusFilter = EpeStatusFilterEnum
  filter: EpeStatusFilterEnum = EpeStatusFilterEnum.all

  screenWidth: number = window.innerWidth;

  @HostListener('window:resize', ['$event'])
  onResize(event:any) {
    this.screenWidth = window.innerWidth
  }

   // Sorting properties
   sortBy: string = 'created_at';
   sortDirection: number = -1;
 
   
   changeSort(property: string) {
     if (this.sortBy === property) {
       this.sortDirection = this.sortDirection * -1;
     } else {
       this.sortBy = property;
       this.sortDirection = 1; 
     }
     this.epes = this.sortEpes();
   }
  
  // alert variables

  showAlert: boolean = false
  alertMessage: string = ''
  alertType: Alert = Alert.SUCCESS

  avg : number = 0

  voteChangeDetectorValue : Vote | null = null

  search ?: string 
  constructor(
    private service: SopService,
    private serviceMongo: EpesService,
    private cache: SopStorage,
    private auth: SessionStorage,
    private logger: Logger,
    private router: Router,
    private applicationsService: ApplicationsService,
    ) {

    }

  ngOnInit(): void {

      if(this.auth.isEpe() && !this.auth.isAdmin() && !this.auth.isCallManager() && !this.auth.isProjectBoard())
        this.router.navigate(['my-applications'])
        
  
      this.epes = this.cache.getEpes()
      if(!this.epes){
        this.applicationsService.getAll({ type: 'epe', include_user: true }).subscribe(
          applications => {
            this.epes = applications.map((app: any) => ({
              ...(app.form_data || {}),
              ...(app.user_info || {}),
              ...app,
              id: app.user_id ?? app.id,
              application_id: app._id?.['$oid'] ?? app._id,
              sop_status: app.status,
            })) as any[]
            this.loading = false
            this.epes.forEach(
              epe => epe.status === 'voted' || epe.status === 'eligible' ? this.updateEpeScore(epe) : null
            )
            this.logger.info(this.epes)
            this.cache.setEpes(this.epes)
            this.epes = this.sortEpes()
          }
        )
      } else {
        this.epes.forEach(
          epe => epe.status === 'voted' || epe.status === 'eligible' ? this.updateEpeScore(epe) : null
        )
        this.epes = this.sortEpes()
        this.loading = false
      }
    }

  exportAuthorized(){
    return this.auth.isAdmin() || this.auth.isCallManager() || this.auth.isProjectBoard()
  }

  stripHtmlTags(content: string): string {
    const div = document.createElement('div');
    div.innerHTML = content;
    return div.textContent || div.innerText || '';
  }

  topicLabel(value: string): string {
    for (const g of TOPIC_GROUPS) {
      for (const s of g.subGroups) {
        if (s.value === value) return `${g.label} > ${s.label}`
        const child = s.children.find(c => c.value === value)
        if (child) return `${g.label} > ${s.label} > ${child.label}`
      }
    }
    return value
  }

  buildCvUrl(cv: any): string {
    if (!cv) return ''
    const str = String(cv).trim()
    if (!str) return ''
    if (/^https?:\/\//i.test(str)) return str
    if (/^[a-f0-9]{24}$/i.test(str)) return `${window.location.origin}/api/v1/applications/cv-download/${str}`
    if (str.startsWith('/')) return `https://hsbooster.eu${str}`
    return str
  }

  formatDate(value: any): string {
    if (!value) return ''
    const str = String(value)
    const date = /^\d+$/.test(str) ? new Date(+str * 1000) : new Date(str)
    if (isNaN(date.getTime())) return ''
    const pad = (n: number) => ('0' + n).slice(-2)
    return `${date.getFullYear()}-${pad(date.getMonth()+1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
  }
 
  exportCSV() {
    console.log(this.epes);
    let data = [];
    for (let epe of this.epes!) {
      let newEpe: exportEpe = {};
      newEpe['Applied at'] = this.formatDate(epe['created_at']);
      newEpe['ID'] = epe['id'] ?? '';
      newEpe['Username'] = epe['username'] ?? '';
      newEpe['Title'] = epe['title'] ? this.stripHtmlTags(epe['title']) : '';
      newEpe['Name(s)'] = epe['name'] ?? '';
      newEpe['Surname'] = epe['surname'] ?? '';
      newEpe['Email'] = epe['email'] ?? '';
      newEpe['Phone Number'] = epe['phone_number'] ?? '';
      newEpe['Website Publication'] = epe['website_publication'] ? 'true' : 'false';
      newEpe['Gender'] = epe['gender'] ?? '';
      newEpe['Country'] = epe['country'] ?? '';
      newEpe['Organisation'] = epe['organisation'] ?? '';
      newEpe['Organisation type'] = epe['organisation_type'] ?? '';
      newEpe['Expertise in Standardisation'] = epe['standardisation_experience']
        ? this.stripHtmlTags(epe['standardisation_experience'])
        : (epe['more_details'] ? this.stripHtmlTags(epe['more_details']) : '');
      newEpe['CV'] = this.buildCvUrl(epe['cv']);
      newEpe['LinkedIN address'] = epe['linkedin'] ?? '';
      newEpe['SOP Status'] = epe['status'] ?? epe['sop_status'] ?? '';
      newEpe['N Votes'] = epe['nvotes'] != null ? epe['nvotes'].toString() : '';
      newEpe['Score'] = epe['score'] != null ? epe['score'].toString() : '';

      newEpe['Topics'] = '';
      const topicsField: any = epe['topics']
      if (Array.isArray(topicsField)) {
        newEpe['Topics'] = topicsField
          .map((t: any) => this.topicLabel(typeof t === 'string' ? t : (t?.value ?? '')))
          .join('\n')
      } else if (topicsField && typeof topicsField === 'object') {
        for (const [firstLevelKey, firstLevelValue] of Object.entries(topicsField as Record<string, any>)) {
          newEpe['Topics'] += firstLevelKey + '\n';
          for (const [secondLevelKey, secondLevelValue] of Object.entries(firstLevelValue as Record<string, any>)) {
            newEpe['Topics'] += '\t' + secondLevelKey + '\n';
            (secondLevelValue as string[]).forEach((thirdLevelKey: string) => {
              newEpe['Topics'] += '\t\t' + thirdLevelKey + '\n';
            });
          }
        }
      }

      // Per-topic evidence + support (new application form stores topics as objects)
      const topicDetails: any[] = Array.isArray(topicsField)
        ? topicsField.filter((t: any) => t && typeof t === 'object')
        : [];
      for (var index = 0; index < 5; index++) {
        const t: any = topicDetails[index];
        const label = index + 1;
        newEpe['Topic ' + label + ' - Selected'] = t ? this.topicLabel(t['value'] ?? '') : '';
        newEpe['Topic ' + label + ' - Evidence of expertise'] = t && t['evidence_of_expertise'] ? this.stripHtmlTags(t['evidence_of_expertise']) : '';
        newEpe['Topic ' + label + ' - Primary support offered'] = t && Array.isArray(t['primary_support_types']) ? t['primary_support_types'].join(', ') : '';
      }

      newEpe['Has Expertise in standardisation?'] = (epe['has_experience'] || epe['standardisation_experience']) ? 'true' : 'false';

      // epe['standardisation_roles']!.forEach(element => {

      for (var index = 0; index < 10; index++) {
        const element: any = epe['standardisation_roles'] ? epe['standardisation_roles'][index] : undefined
        const label = index + 1
        newEpe['Expertise ' + label + ' - Role'] = element ? (element['roles'] ?? element['role'] ?? '') : '';
        newEpe['Expertise ' + label + ' - Years'] = element ? (element['years_of_experience'] ?? element['years'] ?? '') : '';
        newEpe['Expertise ' + label + ' - SDO/NSB/NC'] = element ? (element['sdo'] ?? element['represent'] ?? '') : '';
        newEpe['Expertise ' + label + ' - Other Represention'] = element ? (element['other_sdo'] ?? element['other_represent'] ?? '') : '';
        newEpe['Expertise ' + label + ' - Activities involved'] = element ? (element['details'] ?? '') : '';
        newEpe['Expertise ' + label + ' - Title of TC/SC/WG'] = element ? (element['tc_title'] ?? element['title_sdo'] ?? '') : '';
        newEpe['Expertise ' + label + ' - Number of TC/SC/WG'] = element ? (element['tc_number'] ?? element['number_sdo'] ?? '') : '';
      };

      newEpe['Member of an SDO?'] = epe['sdo_member'] === 'yes' ? 'true' : 'false';

      newEpe['Standardisation support approach'] = epe['fit_support_approach'] ? this.stripHtmlTags(epe['fit_support_approach']) : '';
      newEpe['Experience supporting R&I projects'] = epe['fit_ri_experience'] ? this.stripHtmlTags(epe['fit_ri_experience']) : '';
      newEpe['Knowledge valorisation experience'] = epe['fit_knowledge_valorisation'] ? this.stripHtmlTags(epe['fit_knowledge_valorisation']) : '';
      newEpe['Additional standardisation expertise'] = epe['fit_additional_expertise'] ? this.stripHtmlTags(epe['fit_additional_expertise']) : '';

      newEpe['Indicative availability'] = epe['availability'] ?? '';
      newEpe['Preferred types of services'] = Array.isArray(epe['preferred_services']) ? epe['preferred_services'].join(', ') : '';
      newEpe['Working languages'] = Array.isArray(epe['working_languages']) ? epe['working_languages'].join(', ') : '';
      newEpe['Time zone'] = epe['time_zone'] ?? '';
      newEpe['Potential limitations on availability'] = epe['availability_limitations'] ? this.stripHtmlTags(epe['availability_limitations']) : '';

      newEpe['Confidentiality declaration'] = epe['confidentiality_declaration'] ? 'Agreed' : '';
      newEpe['Accuracy declaration'] = epe['accuracy_declaration'] ? 'Agreed' : '';
      newEpe['Data protection consent'] = epe['data_protection_consent'] ? 'Agreed' : '';
      newEpe['Public profile consent'] = epe['public_profile_consent'] === 'yes' ? 'Yes' : (epe['public_profile_consent'] === 'no' ? 'No' : '');
      newEpe['Newsletter subscription'] = epe['newsletter_subscription'] === 'yes' ? 'Yes' : (epe['newsletter_subscription'] === 'no' ? 'No' : '');

      data.push(newEpe);
    }

    var keys = [
      'Applied at',
      'ID',
      'Username',
      'Title',
      'Name(s)',
      'Surname',
      'Email',
      'Phone Number',
      'Website Publication',
      'Gender',
      'Country',
      'Organisation',
      'Organisation type',
      'Expertise in Standardisation',
      'CV',
      'LinkedIN address',
      'SOP Status',
      'N Votes',
      'Score',
      'Topics',
      'Has Expertise in standardisation?',
    ];

    for (var j = 1; j <= 5; j++) {
      keys.push('Topic ' + j + ' - Selected');
      keys.push('Topic ' + j + ' - Evidence of expertise');
      keys.push('Topic ' + j + ' - Primary support offered');
    }

    for (var j = 1; j <= 10; j++) {
      keys.push('Expertise ' + j + ' - Role');
      keys.push('Expertise ' + j + ' - Years');
      keys.push('Expertise ' + j + ' - SDO/NSB/NC');
      keys.push('Expertise ' + j + ' - Other Represention');
      keys.push('Expertise ' + j + ' - Activities involved');
      keys.push('Expertise ' + j + ' - Title of TC/SC/WG');
      keys.push('Expertise ' + j + ' - Number of TC/SC/WG');
    }

    keys.push('Member of an SDO?');
    keys.push('Standardisation support approach');
    keys.push('Experience supporting R&I projects');
    keys.push('Knowledge valorisation experience');
    keys.push('Additional standardisation expertise');
    keys.push('Indicative availability');
    keys.push('Preferred types of services');
    keys.push('Working languages');
    keys.push('Time zone');
    keys.push('Potential limitations on availability');
    keys.push('Confidentiality declaration');
    keys.push('Accuracy declaration');
    keys.push('Data protection consent');
    keys.push('Public profile consent');
    keys.push('Newsletter subscription');

    let csvOptions = {
      fieldSeparator: ';',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'Applications',
      useBom: true,
      noDownload: false,
      headers: keys,
    };

    new AngularCsv(data, 'EPE-HSBooster', csvOptions);
  }

  searchEpe(search:string){

    if(!this.epes)
      return

    if(search.length > 2){
      this.logger.info(this.epes.filter(x => x.username!.includes(search)), "Search Epes")
      /*setTimeout(()=>{
        this.scrollToRow(this.getPlayers().filter(x => x.name.toLowerCase().includes(search.toLowerCase()))[0].id)
      }, 100)*/
      
    }

  }

  voteChangeDetector(vote: Vote){

    this.logger.info(vote, "Vote change detector:")
    this.voteChangeDetectorValue = vote


  }
  
  changeFilter(newStatus: EpeStatusFilterEnum){
    this.filter = newStatus
  }

  toIter(n:number):Array<any> {
    return Array(n).fill(0).map((x,i)=>i)
  }

  isVoted(epe: Epe): boolean{
    if(!epe.score)
      return false
    return true

  }

  async updateEpeScore(epe: any){
    const appId = epe._id?.$oid || epe._id
    if(!appId) return
    const scores = await lastValueFrom(this.applicationsService.getScore(appId), {defaultValue: null})
    if(!scores)
      return
    epe.score = scores.score
    epe.nvotes = scores.nvotes
    epe.engVariance = scores.engVariance
    epe.standVariance = scores.standVariance

  }

  getBtnText(status:string = ''){

    switch(status){
      case 'draft':
        return 'View details'
      case 'pending':
        return 'Eligibility Check'
      case 'eligible':
        return 'Vote'
      case 'not_eligible':
        return 'View details'
      case 'voted':
        return 'View details'
      default:
        return 'error'

    }

  }

  getEpes():Epe[]{
    if (!this.epes) return []
    if(this.search && this.search.length > 0) {
      const q = this.search.toLowerCase();
      return this.epes.filter(x =>
        String(x.user_id ?? x.id ?? '').includes(q) ||
        (x.form_data?.position ?? '').toLowerCase().includes(q) ||
        (x.user_info?.username ?? x.username ?? '').toLowerCase().includes(q) ||
        (x.user_info?.name ?? '').toLowerCase().includes(q) ||
        (x.user_info?.surname ?? '').toLowerCase().includes(q) ||
        (x.user_info?.email ?? '').toLowerCase().includes(q) ||
        (x.user_info?.organisation ?? '').toLowerCase().includes(q)
      );
    }
    switch(this.filter){
      case EpeStatusFilterEnum.all :
        return this.epes
      case EpeStatusFilterEnum.draft :
        return this.epes.filter( x => x.status === 'draft')
      case EpeStatusFilterEnum.pending :
        return this.epes.filter( x => x.status === 'pending')
      case EpeStatusFilterEnum.eligible :
        return this.epes.filter( x => x.status === 'eligible')
      case EpeStatusFilterEnum.not_eligible :
        return this.epes.filter( x => x.status === 'not_eligible')
      case EpeStatusFilterEnum.voted :
        return this.epes.filter( x => x.status === 'voted')
      default:
        return this.epes
    }
  }

  getAppId(epe: any): string {
    return epe._id?.['$oid'] ?? epe._id ?? String(epe.id ?? '');
  }

  getTopicLabels(epe: any): string[] {
    const topics: any[] = epe.form_data?.topics || [];
    const labels: string[] = [];
    for (const entry of topics) {
      const value = typeof entry === 'string' ? entry : (entry?.value ?? '');
      let found = false;
      for (const group of TOPIC_GROUPS) {
        for (const sub of group.subGroups) {
          if (sub.value === value) { labels.push(`${group.label} > ${sub.label}`); found = true; break; }
          const child = sub.children.find(c => c.value === value);
          if (child) { labels.push(`${group.label} > ${sub.label} > ${child.label}`); found = true; break; }
        }
        if (found) break;
      }
      if (!found) labels.push(value);
    }
    return labels;
  }

  getTopicDetails(epe: any): { label: string; evidence: string; support: string[] }[] {
    const topics: any[] = epe.form_data?.topics || [];
    return topics
      .filter(t => typeof t !== 'string')
      .map(t => ({
        label: this.topicLabel(t?.value ?? ''),
        evidence: t?.evidence_of_expertise || '',
        support: t?.primary_support_types || [],
      }));
  }

  getStatusLabel(status: string = ''): string {
    const map: Record<string, string> = {
      draft: 'Draft', pending: 'Pending', eligible: 'Eligible',
      not_eligible: 'Not Eligible', voted: 'Voted', proactive: 'Proactive',
    };
    return map[status] || status;
  }

  getStatusBadgeClass(status: string = ''): string {
    const map: Record<string, string> = {
      draft: 'label-default', pending: 'label-warning', eligible: 'label-success',
      not_eligible: 'label-danger', voted: 'label-info', proactive: 'label-primary',
    };
    return map[status] || 'label-default';
  }

  getExpand(id: string = ''): string {
    return id === this.selected ? 'Close details' : 'Open details';
  }

  getExpandImg(id: string = ''): string {
    return id === this.selected ? 'reduce' : 'expand';
  }

  expand(id: string = '') {
    this.selected = this.selected === id ? '' : id;
  }

  sortEpes(): Epe[] {
    if (!this.epes) return []

    switch(this.sortBy){
      case 'name':
        if (this.sortDirection == 1)
          return this.epes.sort((a, b) => (a.user_info?.name ?? a.name ?? '').localeCompare(b.user_info?.name ?? b.name ?? ''))
        else
          return this.epes.sort((a, b) => (b.user_info?.name ?? b.name ?? '').localeCompare(a.user_info?.name ?? a.name ?? ''))
      case 'surname':
        if (this.sortDirection == 1)
          return this.epes.sort((a, b) => (a.user_info?.surname ?? a.surname ?? '').localeCompare(b.user_info?.surname ?? b.surname ?? ''))
        else
          return this.epes.sort((a, b) => (b.user_info?.surname ?? b.surname ?? '').localeCompare(a.user_info?.surname ?? a.surname ?? ''))
      case 'email':
        if (this.sortDirection == 1)
          return this.epes.sort((a, b) => (a.user_info?.username ?? a.username ?? '').localeCompare(b.user_info?.username ?? b.username ?? ''))
        else
          return this.epes.sort((a, b) => (b.user_info?.username ?? b.username ?? '').localeCompare(a.user_info?.username ?? a.username ?? ''))
      case 'score':
        if (this.sortDirection == 1){
          let epesVoted = this.epes.filter(x => x.score)
          console.log('voted',epesVoted)
          let epesNotVoted = this.epes.filter(x => !x.score)
          console.log('notVOted',epesNotVoted)
          return epesVoted.sort((a, b) => a.score! - b.score!).concat(epesNotVoted)
        }else{
          let epesVoted = this.epes.filter(x => x.score)
          let epesNotVoted = this.epes.filter(x => !x.score)
          return epesVoted.sort((a, b) => b.score! - a.score!).concat(epesNotVoted)
        }
      case 'created_at':
        return [...this.epes].sort((a, b) => {
          const parse = (v: any) => { const s = String(v ?? 0); return /^\d+$/.test(s) ? +s * 1000 : new Date(s).getTime(); };
          return this.sortDirection * (parse(a.created_at) - parse(b.created_at));
        });
    }

    return this.epes

  }

  addAlert(message: string, type: Alert){

    this.alertMessage = message
    this.alertType = type
    this.showAlert = true

  }

  

  truncateFloat(n : number) : number {
    return Math.floor(n * 100) / 100
  }

  isWarning(epe: Epe): boolean{
    
    if(!epe.engVariance || !epe.standVariance)
      return false
    
    if(epe.engVariance >=2 || epe.standVariance >= 2)
      return true

    return false
  }
  
}
